import React from "react";
import classes from "./SwitchButton.module.css";

const SwitchButton = ({ name, defaultChecked, handleChange, checked }) => {
  const value = /(true|false)/.test(checked) ? { checked } : null;
  return (
    <label>
      <input
        onChange={handleChange}
        defaultChecked={defaultChecked}
        type="checkbox"
        name={name}
        className={[classes.iosSwitch, classes.green, classes.bigswitch].join(
          " "
        )}
        {...value}
      />
      <div>
        <div></div>
      </div>
    </label>
  );
};

export default SwitchButton;

export const SwitchButtonField = ({ field, ...props }) => {
  const color = props.color || "green";
  return (
    <label>
      <input
      style={props?.style||{}}
        type="checkbox"
        className={[classes.iosSwitch, classes[color], classes.tinyswitch].join(
          " "
        )}
        {...field}
        {...props}
      />
      <div>
        <div></div>
      </div>
    </label>
  );
};
